import type { IcIcon } from "./types";

export const IcMosaicStatus: IcIcon = (properties) => (
  <svg viewBox="0 0 28 26" xmlns="http://www.w3.org/2000/svg" {...properties}>
    <g fill="none" fillRule="evenodd">
      <path
        d="M13.995.5.5 8.5v9l13.495 8 13.505-8v-9z"
        fill="#FFF"
        fillRule="nonzero"
      />
      <path d="m8.247 13.003 5.746 3.333V9.671z" fill="#4BADE0" />
      <path d="M13.993 9.671v6.664l5.747-3.332z" fill="#2A72B5" />
      <path d="M13.993 9.671 8.247 6.339v6.664z" fill="#53BCEB" />
      <path d="m13.993 9.671 5.747 3.332V6.339z" fill="#115EAD" />
      <path d="m19.74 13.003 5.746 3.333V9.671z" fill="#123368" />
      <path d="M25.487 9.671 19.74 6.339v6.664z" fill="#264575" />
      <path d="m19.74 6.339-5.747-3.332v6.664z" fill="#98D7F3" />
      <path d="m19.734 19.664-5.741-3.328v6.65z" fill="#98BCDC" />
      <path d="m8.247 19.667 5.746-3.332-5.746-3.332z" fill="#2A72B5" />
      <path
        d="M13.993 22.986v-6.651l-5.746 3.332v.001l5.735 3.325z"
        fill="#84ABD1"
      />
      <path d="M19.74 13.003v6.658l5.746-3.325z" fill="#00245D" />
      <path
        d="m19.74 13.003-5.747 3.332v.001l5.741 3.328.006-.003z"
        fill="#0D3F8F"
      />
      <path d="M8.247 13.003V6.339L2.5 9.671z" fill="#64C3ED" />
      <path d="M2.5 9.671v6.665l5.747-3.333z" fill="#86D0F1" />
      <path d="M8.247 13.003 2.5 16.336l5.747 3.332v-.001z" fill="#A9DDF5" />
      <path d="M13.993 9.671V3.007L8.247 6.339z" fill="#BAE4F7" />
    </g>
  </svg>
);
